import React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import { FieldHookConfig, useField } from 'formik';
import { setFieldOnSessionStorage } from '../../helpers/helpers';

type CheckboxProps = FieldHookConfig<string> & {
  label: string;
  id: string;
  formName?: string;
  objectId?: string;
  required?: boolean;
  type: string;
  optionStyles?: React.CSSProperties;
};

const FormikCheckbox = (props: CheckboxProps) => {
  const [field] = useField(props);
  const { label, id, formName, objectId = '', required = false, optionStyles = {} } = props;

  const changeField = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (formName) {
      setFieldOnSessionStorage(formName, objectId, field.name, e.currentTarget.checked);
    }
    field.onChange(e);
  };

  return (
    <FormControlLabel
      control={
        <Checkbox id={id} required={required} {...field} onChange={changeField} sx={optionStyles} />
      }
      label={label}
    />
  );
};

export default FormikCheckbox;
